import { CoachAssignmentNode, ProviderAssignmentDisplayType } from 'src/generated/webapp_gql';

const resolvers = {
    CoachAssignmentNode: {
        providerDisplayType: ({ isPathwayAssignment, coach }: CoachAssignmentNode) =>
            isPathwayAssignment
                ? ProviderAssignmentDisplayType.PathwaySpecialist
                : ProviderAssignmentDisplayType[coach?.providerType as string],
    },
};

export default resolvers;
